import { unsafeCoerce } from 'fp-ts/lib/function';
import { DisplayAppointment } from '../../schema/hannibal/types.generated';
import { NetworkService } from '../NetworkService';
import { SsrData } from '../SsrData';
import { DEFAULT_THEME_PARAMS, HeThemeParameters } from './HeThemeParameters.type';
import { buildThemeParamUrl, WhiteLabelEntityType } from './buildThemeParamUrl';

export class ThemeService {
  constructor(private ssrData: SsrData, private network: NetworkService) {}

  private slot = this.ssrData.slot('THEME_PARAMS', () => ({ params: DEFAULT_THEME_PARAMS }));

  public load = async (owner: ThemeOwner) => {
    if (owner.bookingFormDisplayType === DisplayAppointment.Network) {
      this.slot.params = { loading: false, themeIsPresent: false };
    } else {
      try {
        const url = buildThemeParamUrl(owner.id, owner.kind);
        const response = await this.network.fetch(url);
        const json: unknown = await response.json();
        this.slot.params = { ...unsafeCoerce(json), loading: false, themeIsPresent: true };
      } catch (_error) {
        // whitelabel returns non-json when theres no theme,
        // so this error also catches the non-whitelabel widget form
        this.slot.params = { loading: false, themeIsPresent: false };
      }
    }
  };

  public getParams = (): HeThemeParameters => this.slot.params;
}

interface ThemeOwner {
  kind: WhiteLabelEntityType;
  id: string;
  bookingFormDisplayType?: DisplayAppointment;
}
